"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProductsSearchEndpointRequest = exports.APISortOrder = exports.APISortOption = void 0;
const ProductSearchQuery_1 = require("../../types/ProductSearchQuery");
const ProductWith_1 = require("../../types/ProductWith");
var APISortOption;
(function (APISortOption) {
    APISortOption["Price"] = "price";
    APISortOption["DateAdded"] = "new";
    APISortOption["Reduction"] = "reduction";
})(APISortOption || (exports.APISortOption = APISortOption = {}));
var APISortOrder;
(function (APISortOrder) {
    APISortOrder["Ascending"] = "asc";
    APISortOrder["Descending"] = "desc";
})(APISortOrder || (exports.APISortOrder = APISortOrder = {}));
function createProductsSearchEndpointRequest(parameters) {
    return {
        method: 'GET',
        endpoint: 'products',
        params: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (parameters.with
            ? { with: (0, ProductWith_1.productWithQueryParameterValues)(parameters.with).join(`,`) }
            : undefined)), (0, ProductSearchQuery_1.queryParamsFromProductSearchQuery)(parameters.where)), (parameters.pricePromotionKey
            ? {
                pricePromotionKey: parameters.pricePromotionKey,
            }
            : undefined)), (parameters.sort && parameters.sort.by
            ? { sort: parameters.sort.by }
            : undefined)), (parameters.sort && parameters.sort.direction
            ? { sortDir: parameters.sort.direction }
            : undefined)), (parameters.sort && parameters.sort.score
            ? { sortScore: parameters.sort.score }
            : undefined)), (parameters.sort && parameters.sort.channel
            ? { sortChannel: parameters.sort.channel }
            : undefined)), (parameters.sort && parameters.sort.sortingKey
            ? { sortingKey: parameters.sort.sortingKey }
            : undefined)), (parameters.pagination && parameters.pagination.page
            ? { page: parameters.pagination.page }
            : undefined)), (parameters.pagination && parameters.pagination.perPage
            ? { perPage: parameters.pagination.perPage }
            : undefined)), (parameters.campaignKey
            ? { campaignKey: parameters.campaignKey }
            : undefined)), (parameters.includeSellableForFree
            ? { includeSellableForFree: parameters.includeSellableForFree }
            : undefined)), (parameters.includeSoldOut
            ? { includeSoldOut: parameters.includeSoldOut }
            : undefined)), (parameters.minProductId
            ? { minProductId: parameters.minProductId }
            : undefined)), (parameters.orFiltersOperator &&
            parameters.orFiltersOperator.length > 1
            ? { orFiltersOperator: parameters.orFiltersOperator.join(',') }
            : undefined)),
    };
}
exports.createProductsSearchEndpointRequest = createProductsSearchEndpointRequest;
